/**
 * 预约表单步骤
 */
export const RESERVE_STEP_INDEX = {
  RESERVE_ITEMS: 1,
  TIME_STORE: 2,
  CONTACT_INFO: 3,
}

// 维保类型 code
export const MAINTANCE_TYPE_CODE = {
  CHECK: 21,
  REPAIR: 22,
}

export const DEFAULT_CITY_CODE = '440106'; // 广州
export const DEFAULT_CITY = '广州'; // 广州

// 预约单状态
export enum RESERVE_ORDER_STATUS {
  SUCCESS = 1,
  RESERVE_CANCEL = 5,
  ARRIVED = 6,
  RESERVE_SUCCESS = 7,
}

export const TAB_ID_SET = {
  DATE_TAB: 0,
  STORE_TAB: 1,
}
// 预约门店及时间 tab 内容
export const STORE_TIME_TAB_LIST = [
  {
    id: TAB_ID_SET.DATE_TAB,
    name: '按日期'
  },
  {
    id: TAB_ID_SET.STORE_TAB,
    name: '按门店'
  },
]

// 预约失败枚举文案映射
export const RESERVE_FAIL_TEXT_MAP = {
  42103: '已存在预约单，无需重复预约',
  42115: '没有取送车权益，请确认取送车权益可用次数大于0',
  46105: '非常抱歉，订单无法创建请尝试重新提交，或联系客服',
  42107: '为提供更好的服务，暂不开放预约当天时间',
  42109: '预约已满，请更新预约日期或选择其他门店',
  42106: '预约失败，请返回修改后再次提交，或者联系客服咨询',
  42114: '修改失败，请重新预约或者联系客服咨询'
}

export const ORDER_TAB_MAP = {
  COMPREHENSIVE: 0,
  DISTANCE: 1
}

export const ORDER_TAB_LIST = [
  {
    id: ORDER_TAB_MAP.COMPREHENSIVE,
    name: '综合排序'
  },
  {
    id: ORDER_TAB_MAP.DISTANCE,
    name: '距离优先'
  }
]
